<h2 mat-dialog-title>{{pageTitle}}</h2>
<span style="padding-left: 10px;">{{subtitle}}</span>
<mat-dialog-content>
    <view-design-pages [designPageId]="designPageId" [allowViewEdit]="true" (designPageUpdated)="designPageUpdatedHandler()"></view-design-pages>
</mat-dialog-content>
<mat-dialog-actions>
    <div class='flex-footer-left'>
        <tyl-button image="add.png" label="Add Version" (clickEvent)="addClick()" *ngIf="showAddButton"></tyl-button>
    </div>
    <div class='flex-footer-right'>
        <tyl-button image="cancel.png" label="Close" (clickEvent)="closeClick()"></tyl-button>
    </div>
</mat-dialog-actions>